import { SOMETHING_WRONG_MSG } from '@/shared/constants';
import { useMutation, useToast } from '@/shared/helpers';
import { UPSERT_APP_LEAD } from './gql';
import type { UpsertAppLeadInput, AppLead } from './types';

interface UpsertAppLeadResponse {
  upsertAppLead: AppLead;
}

interface UpsertAppLeadVariables {
  input: UpsertAppLeadInput;
}

const useUpsertAppLead = (onComplete?: (data?: UpsertAppLeadResponse) => void) => {
  const { showErrorToast } = useToast();

  return useMutation<UpsertAppLeadResponse, UpsertAppLeadVariables>(UPSERT_APP_LEAD, {
    onCompleted: (data) => {
      onComplete?.(data);
    },
    onError: () => {
      showErrorToast(SOMETHING_WRONG_MSG);
    },
  });
};

const model = { useUpsertAppLead };

export default model;
